export default __webpack_public_path__ + "static/media/sponsor-wanan.395776b6.png";